/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';
import withPreferredLocale from 'redux/wrappers/withPreferredLocale';

export interface Localizable {
  default: string;
  i18n: object;
}

function getLocalText(text, languageCode) {
  if (!text) return '';

  if (typeof text === 'string') {
    return text;
  } else if (!text.default) {
    return '';
  }

  if (text.i18n[languageCode]) {
    return text.i18n[languageCode];
  } else if (text.default) {
    return text.default;
  }

  const keys = Object.keys(text.i18n);
  return keys.length ? text.i18n[keys[0]] : '';
}

interface Props {
  text: Localizable;
  preferredLocale?: any;
}

export const LocalText = withPreferredLocale((props: Props) => {
  return (
    <span>{getLocalText(props.text, props.preferredLocale.language_code)}</span>
  );
});
